import config from '../../config';
import { getAuthHeaders, handleResponse, handleNoContentResponse } from './common';

const endpoint = `${config.api.url}/organization/custom-appointment-types`;

const request = async (url, options = {}) => {
  const response = await fetch(url, { ...options, headers: getAuthHeaders() });
  return options.method === 'DELETE' ? handleNoContentResponse(response) : handleResponse(response);
};

const customAppointmentTypesApi = {
  getAll: (includeArchived = false) => request(`${endpoint}?includeArchived=${includeArchived}`),
  create: (data) => request(endpoint, { method: 'POST', body: JSON.stringify(data) }),
  update: (referenceId, data) => request(`${endpoint}/${referenceId}`, { method: 'PUT', body: JSON.stringify(data) }),
  archive: (referenceId) => request(`${endpoint}/${referenceId}`, { method: 'DELETE' }),
  restore: (referenceId) => request(`${endpoint}/${referenceId}/restore`, { method: 'POST' }),
};

export default customAppointmentTypesApi;
